import {
    Pause,
    Play,
} from "lucide-preact";
import {
    useCallback,
    useEffect,
    useState,
} from "preact/compat";

import {
    Button,
} from "@mrflark/ui";

type PauseState = {
    pause_process_media: boolean;
    pause_reanalyze_media: boolean;
};

export const InferencePauseButtons = () => {
    const [state, setState] = useState<PauseState>({
        pause_process_media: false,
        pause_reanalyze_media: false,
    });
    const [loading, setLoading] = useState<string | null>(null);

    useEffect(() => {
        fetch("/api/admin/settings")
            .then((response) => response.json())
            .then((data: { settings: Record<string, string>; }) => {
                setState({
                    pause_process_media:
                        data.settings.pause_process_media === "true",
                    pause_reanalyze_media:
                        data.settings.pause_reanalyze_media === "true",
                });
            })
            .catch(() => {/* ignore */});
    }, []);

    const toggle = useCallback(async (key: keyof PauseState) => {
        const newValue = !state[key];
        setState((prev) => ({
            ...prev,
            [key]: newValue,
        }));
        setLoading(key);
        try {
            await fetch(`/api/admin/settings/${key}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    value: String(newValue),
                }),
            });
        } catch {
            setState((prev) => ({
                ...prev,
                [key]: !newValue,
            }));
        } finally {
            setLoading(null);
        }
    }, [state]);

    return (
        <>
            <Button
                variant={state.pause_process_media ? "error" : "secondary"}
                size="sm"
                onClick={() => toggle("pause_process_media")}
                disabled={loading === "pause_process_media"}
            >
                {state.pause_process_media
                    ? (
                        <>
                            <Play size={14} className="mr-1" />Resume Local
                        </>
                    )
                    : (
                        <>
                            <Pause size={14} className="mr-1" />Pause Local
                        </>
                    )}
            </Button>
            <Button
                variant={state.pause_reanalyze_media ? "error" : "secondary"}
                size="sm"
                onClick={() => toggle("pause_reanalyze_media")}
                disabled={loading === "pause_reanalyze_media"}
            >
                {state.pause_reanalyze_media
                    ? (
                        <>
                            <Play size={14} className="mr-1" />Resume Remote
                        </>
                    )
                    : (
                        <>
                            <Pause size={14} className="mr-1" />Pause Remote
                        </>
                    )}
            </Button>
        </>
    );
};
